import { io } from "socket.io-client";

export const socketClient = io(import.meta.env.VITE_NOTIFICATION_SERVICE_ENDPOINT, { 
  autoConnect: true,
  reconnectionAttempts: 2,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,  
})